import React, { useState } from 'react';
import Header from './Header';

// STUB: REPLACE THIS WITH YOUR ACTUAL FORMSPREE FORM ID
const FORMSPREE_ID = 'YOUR_FORM_ID_HERE';

export default function ContactPage() {
    const [form, setForm] = useState({
        firstName: '',
        lastName: '',
        age: '',
        phone: '',
        email: '',
        isProfessional: 'no',
        message: ''
    });

    function handleChange(e) {
        setForm({ ...form, [e.target.name]: e.target.value });
    }

    return (
        <div className="nada-page">
            <Header />
            <main style={{ minHeight: '80vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <section className="contact-section py-5">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-9 px-0"> {/* Width adjusted slightly */}
                                <h2 className="text-center">Join Us</h2>

                                <form
                                    action={`https://formspree.io/f/xkgdkzke`}
                                    method="POST"
                                    className="contact-form-card"
                                >
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">First Name</label>
                                            <input
                                                name="firstName"
                                                value={form.firstName}
                                                onChange={handleChange}
                                                className="form-control"
                                                required
                                                placeholder="First Name"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Last Name</label>
                                            <input
                                                name="lastName"
                                                value={form.lastName}
                                                onChange={handleChange}
                                                className="form-control"
                                                required
                                                placeholder="Last Name"
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Age</label>
                                            <input
                                                name="age"
                                                type="number"
                                                value={form.age}
                                                onChange={handleChange}
                                                className="form-control"
                                                required
                                                placeholder="Your Age"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Phone Number</label>
                                            <input
                                                name="phone"
                                                type="tel"
                                                value={form.phone}
                                                onChange={handleChange}
                                                className="form-control"
                                                required
                                                placeholder="Phone Number"
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Email</label>
                                        <input
                                            name="email"
                                            type="email"
                                            value={form.email}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                            placeholder="name@example.com"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label d-block">Are you a teaching professional?</label>
                                        <div className="d-flex gap-4 mt-2">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="isProfessional"
                                                    id="profYes"
                                                    value="yes"
                                                    checked={form.isProfessional === 'yes'}
                                                    onChange={handleChange}
                                                    style={{ borderColor: 'var(--nada-brown)' }}
                                                />
                                                <label className="form-check-label" htmlFor="profYes">Yes</label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="isProfessional"
                                                    id="profNo"
                                                    value="no"
                                                    checked={form.isProfessional === 'no'}
                                                    onChange={handleChange}
                                                    style={{ borderColor: 'var(--nada-brown)' }}
                                                />
                                                <label className="form-check-label" htmlFor="profNo">No</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Message</label>
                                        <textarea
                                            name="message"
                                            rows="4"
                                            value={form.message}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                            placeholder="How can we help you?"
                                        ></textarea>
                                    </div>

                                    <div className="text-center mt-4">
                                        <button type="submit" className="btn btn-nada">
                                            Send Message
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}
